export default __webpack_public_path__ + "static/media/snapshotofterminal.a44724a1.jpg";